import React from "react";
import styles from "./index.module.scss";
import { Icon } from "antd";
import { LeaveScreenItem } from "../../../../../../service/exam";

export default function ShiftRecord({ leaveName, time }: LeaveScreenItem) {
    return (
        <div className={styles.root}>
            <Icon className={styles.icon} type="clock-circle" />
            <div className={styles.time}>{time}</div>
            <div className={styles.tip}>{leaveName}</div>
        </div>
    );
}
